import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What communication protocols are used in IoT?",
    category: "Technology",
    description:
      "IoT uses protocols like Wi-Fi, MQTT, Bluetooth, Zigbee, LoRa, and HTTP. These protocols enable devices to communicate efficiently depending on range, power consumption, and application requirements.",
  },
  {
    title: "What industries use IoT the most?",
    category: "Trending",
    description:
      "IoT is widely used in healthcare, smart homes, agriculture, manufacturing, logistics, transportation, and retail. It helps automate tasks, monitor equipment, improve efficiency, and enable smart decision-making based on real-time data.",
  },
  {
    title: "How does IoT benefit daily life?",
    category: "Design",
    description:
      "IoT enhances convenience through smart lighting, home automation, wearable health monitors, security systems, and energy-efficient appliances. It improves comfort, safety, and productivity by enabling intelligent control of everyday devices.",
  },
  {
    title: "What career roles are available in IoT?",
    category: "Design",
    description:
      "IoT offers roles like IoT Developer, Embedded Engineer, Firmware Developer, IoT Cloud Engineer, Automation Engineer, and IoT Security Analyst. These roles focus on device programming, connectivity, cloud integration, and security.",
  },
  {
    title: "What tools and platforms are used in IoT development?",
    category: "Design",
    description:
      "Developers use platforms like Arduino IDE, ESP-IDF, Node-RED, AWS IoT, Firebase, and ThingsBoard. These tools help program devices, build dashboards, automate workflows, and manage cloud-connected systems.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
